export const APP_REDUCER_NAME = 'appContainer';

export enum ACTIONS {
  SHOW_SIDEBAR_MENU = 'SHOW_SIDEBAR_MENU',
  SET_SEARCH_ACTIVE = 'SEARCH_ACTIVE',
  SET_USER_DATA = 'SET_USER_DATA',
  SET_SUCCESS_REG = 'SET_SUCCESS_REG',
}
